export default __webpack_public_path__ + "static/media/cybercats_big.cd4d38f0.jpg";